"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.getContext = void 0;
var rogueScene_create_sidecar_1 = require("./rogueScene_create-sidecar");
var rogueScene_update_sidecar_1 = require("./rogueScene_update-sidecar");
var _context = null;
var getContext = function () {
    if (!_context) {
        throw new Error('context not ready!');
    }
    return _context;
};
exports.getContext = getContext;
var create = function () {
    _context = rogueScene_create_sidecar_1.rogueScene_create.create();
};
exports.create = create;
var update = function (time, delta) {
    rogueScene_update_sidecar_1.rogueScene_update.update(time, delta);
};
exports.update = update;
